import React from "react";
import { Container } from "react-bootstrap";
import "../assets/css/ContentScreens.css";

const HouseRulesScreen = () => {
  return (
    <Container className="content-screen">
      <h1>House Rules</h1>

      <section>
        <h2>CLEANING & EXITING THE CLUBHOUSE</h2>
        <ul>
          <li>
            It is the responsibility of each member and guest to keep the
            Clubhouse clean. Please clean tables, wash & return plates, cups,
            glasses, etc., to the cupboards after use and vacuum as necessary.
          </li>
          <li>
            Member Chairperson(s) for a Club-sponsored event is/are responsible
            for coordinating a cleanup committee following each event.
          </li>
          <li>
            Empty filled garbage cans and place filled bags in the trash
            dumpster in the parking lot. Make sure to replace the plastic liner
            in each garbage can.
          </li>
          <li>
            There are both Returnable (green) and Recycling (blue) bins
            throughout the club.
          </li>
        </ul>
        <ul>
          <li>
            The green Returnable bins are only for those items with 5¢ New York
            Recycling Credits such as beverage aluminum cans, and plastic and
            glass bottles and jars
          </li>
          <li>
            The blue Recycling bins are for recyclable items such as cardboard,
            and metal, plastic, and glass containers without the 5¢ New York
            Recycling Credits
          </li>
          <li>
            All items are to be rinsed out before placing in the Returnable and
            Recycling bins.
          </li>
        </ul>
        <ul>
          <li>
            Wine bottles should <strong>NOT</strong> be placed in either the
            recycling bins or the garbage cans. They are to be taken home or
            placed in the zero-sort recycling dumpster.
          </li>
          <li>
            If you are the last to leave the Clubhouse it is your responsibility
            to be sure of the following:
          </li>
        </ul>
        <ol>
          <li>All doors locked</li>
          <li>Gas turned off on grills</li>
          <li>Gas turned off in fireplace</li>
          <li>Stoves & ovens turned off</li>
          <li>
            Heat turned down to 62 degrees (thermostat is located at coffee
            station by the kitchen).
          </li>
          <li>
            All lights off. The labeled "Tony Switch" at the base of the
            interior stairs shuts off all lights.
          </li>
        </ol>
      </section>

      <section>
        <h2>GUESTS</h2>
        <ul>
          <li>
            Guests are welcome to ESC but must be accompanied by a hosting
            member at all times. However, members are advised that the same
            person cannot be a guest of the Club for lunch on Saturday or Sunday
            more than four (4) times during one ski season, with the exception
            of a single member's date. A Saturday and Sunday are considered two
            times.
          </li>
          <li>
            Guests are not permitted to store any equipment at the Club
            overnight.
          </li>
          <li>
            Host members are responsible for advising their guests on the rules
            of the Club.
          </li>
          <li>
            Guests are welcome to Club parties, but a guest's party fee must be
            paid by the hosting member. Guests are NOT permitted to pay their
            own way.
          </li>
          <li>
            If a guest arrives at the Club before the host, the guest must
            remain downstairs until the hosting member arrives.
          </li>
          <li>
            If a member is going to bring more than four (4) guests to a party,
            the member is asked to inform the Party Host(s) at least 1 week in
            advance.
          </li>
        </ul>
      </section>

      <section>
        <h2>PARKING</h2>
        <ul>
          <li>
            As the parking lot sometimes has inadequate capacity, members are
            requested to:
            <ul>
              <li>
                ask their guests to park on the lower road during weekends, and
              </li>
              <li>
                leave the key in their car when parking in the center aisle of
                the lot.
              </li>
            </ul>
          </li>
          <li>
            When parking, pull your vehicle as close to the edge and as close to
            the hill as possible.
          </li>
          <li>
            Members must display the Club's ESC parking tag at all times on
            their vehicle's rearview mirror with their name facing out when
            parking in the Club lot during the ski season.
          </li>
          <li>
            The weekend parking lot attendant has been instructed not to permit
            anyone to park in the Club lot if an ESC parking tag is not
            displayed.
          </li>
          <li>ESC parking tags are not transferable.</li>
        </ul>
      </section>

      <section>
        <h2>SECURITY SYSTEM</h2>
        <ul>
          <li>
            Each member is assigned his or her own key fob and personal keypad
            code. It is recommended that you store your individual code on your
            mobile phone for quick access.
          </li>
          <li>
            If you have lost or misplaced your key fob or forgotten your code
            please contact board member Al Colucci.
          </li>
        </ul>
      </section>

      <section>
        <h2>STORAGE</h2>
        <ul>
          <li>
            Slots are assigned for members' skis, boards, and boots. Members are
            expected to keep their equipment in their assigned spots. Slots may
            be reassigned by contacting board member Al Colucci.
          </li>
          <li>
            Non-Resident members may not store their equipment at the Club on a
            permanent basis. When visiting the area for a short period during
            the ski season they may request temporary storage (if available) by
            contacting board member Al Colucci.
          </li>
          <li>
            Reminder: Guests are not permitted to store any equipment at the
            club.
          </li>
          <li>
            Skis, poles, and snowboards must be kept clear of Clubhouse
            entrances. These items should not be left lying on the ground. They
            are to be placed in the racks on the outside of the Clubhouse.
          </li>
          <li>
            Picnic baskets and coolers may be stored downstairs only in the
            "cubbies" located behind the stairs, or on the shelf above the coat
            hooks next to the stairs.
          </li>
          <li>
            Children over the age of 21 (unless they are members) are not
            permitted to store their equipment overnight.
          </li>
        </ul>
      </section>

      <section>
        <h2>IN-SEASON CLUB USAGE</h2>
        <p>
          Use of the ESC Clubhouse is limited to members and their invited
          guests. When using the Clubhouse, the following In-Season Usage
          Guidelines should be observed:
        </p>
        <ul>
          <li>
            Tables are available on a first-come basis and cannot be reserved.
          </li>
          <li>
            During a Club-sponsored event the Club upstairs level cannot be used
            for any other social event. However, skiing access to the Club's
            lower level is always available to any Club member.
          </li>
          <li>
            Members and their guests who are present when a party is in progress
            are expected to pay the party admittance price.
          </li>
          <li>
            Private parties are not permitted in season. The Club remains open
            to all members. "Private parties" are defined as exclusive usage of
            the Club.
          </li>
          <li>
            No commercial endeavors may be conducted in the Clubhouse at any
            time (i.e., events for entertaining staff/customers, conducting
            non-ESC meetings, etc.).
          </li>
          <li>Pets are not allowed in the Clubhouse.</li>
          <li>
            Smoking or vaping in the Clubhouse, common areas, and decks is not
            permitted.
          </li>
        </ul>
      </section>

      <section>
        <h2>OFF-SEASON CLUB USAGE</h2>
        <ul>
          <li>
            The ESC Clubhouse is available during the "off-season" (mid-April to
            mid-November) on a case-by-case basis. Send requests for an
            application and guidelines to the Membership Chair at
            membership@ellicottvilleskiclub.com
          </li>
          <li>
            Off-season events are considered "Member-Hosted Events" and are
            limited to no more than 60 people.
          </li>
          <li>
            All applications for off-season usage are considered on a first-come
            basis and must be received no less than 30 days prior to the
            proposed event.
          </li>
          <li>
            Applications for off-season usage are subject to board review.
          </li>
          <li>
            There is a $600 non-refundable Usage Fee for approved events that
            covers insurance and cleaning.
          </li>
          <li>
            A security fee of $250 fee is required and refundable once a
            satisfactory walk-through with a Board or House Committee member is
            completed.
          </li>
          <li>
            For approved events, insurance coverage as detailed in the
            application for Off-Season Usage is to be coordinated with the
            Insurance Committee Chair and must be completed within 5 days of the
            approved event.
          </li>
        </ul>
      </section>
    </Container>
  );
};

export default HouseRulesScreen;
